import { Alert } from '@rsos/reduxDataStore/src/features/alerts/alerts.types';

/**
 * Location Restricted is unique to executive calls that do not have a location
 */
const isLocationRestricted = (alert: Alert) => {
  const hasLocation = alert?.location
    ? Object.keys(alert.location).length > 0
    : false;

  return !hasLocation;
};

export default isLocationRestricted;
